import { apiRequest } from './api'

export const reviewsService = {
  // Get aggregated reviews for a user
  getUserReviews: async (userId) => {
    try {
      const response = await apiRequest(`/reviews/user/${userId}`, {
        method: 'GET',
      })

      return {
        success: true,
        data: response.data,
        message: 'User reviews fetched successfully',
      }
    } catch (error) {
      return {
        success: false,
        error: error.message,
        message: 'Failed to fetch user reviews',
        data: null,
      }
    }
  },
}
